module.exports = __webpack_public_path__ + "img/Logo.78d932cb.png";